import styled from "styled-components";

const INK = "#1d2340";
const PAPER = "#f8f5ee";
const LINE = "#d4ccb8";
const PEN = "#d9412b";

const BrandLogo = ({ height = 28, inverted = false, markOnly = false }) => {
    const board = inverted ? PAPER : INK;
    const sheet = inverted ? "#fffdf7" : PAPER;

    return (
        <Wrap $height={height} aria-label="패스로">
            <Mark viewBox="0 0 32 32" aria-hidden="true" $size={height}>
                <rect width="32" height="32" rx="8" fill={board} />
                <rect x="5" y="5" width="22" height="22" rx="3" fill={sheet} />
                <path d="M8.5 12.4h15" stroke={LINE} strokeWidth="2" strokeLinecap="round" />
                <path d="M8.5 17.2h11" stroke={LINE} strokeWidth="2" strokeLinecap="round" />
                <path d="M8 22.2h15.6" stroke={PEN} strokeWidth="2.2" strokeLinecap="round" />
                <circle cx="22.2" cy="17" r="4" fill="none" stroke={PEN} strokeWidth="2" />
            </Mark>
            {!markOnly && (
                <Word $inverted={inverted} $size={height}>
                    PASS<Ro>RO</Ro>
                </Word>
            )}
        </Wrap>
    );
};

export default BrandLogo;

const Wrap = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: ${({ $height }) => $height}px;
    line-height: 1;
    user-select: none;
`;

const Mark = styled.svg`
    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    flex-shrink: 0;
    display: block;
`;

const Word = styled.span`
    position: relative;
    top: 0.5px;
    font-size: ${({ $size }) => Math.round($size * 0.64)}px;
    font-weight: 700;
    letter-spacing: -0.045em;
    color: ${({ $inverted }) => ($inverted ? PAPER : INK)};
`;

const Ro = styled.span`
    position: relative;

    &::after {
        content: "";
        position: absolute;
        left: 0;
        right: -1px;
        bottom: 1px;
        height: 2px;
        background: ${PEN};
        border-radius: 2px;
        transform: rotate(-3deg);
    }
`;
